export enum Status {
  PENDING = 'pending',
  APPROVED = 'approved',
  DECLINED = 'declined',
  EXPIRED = 'expired',
}

export enum PaymentStatus {
  PENDING = 'pending',
  PAID = 'paid',
  PAID_WITH_ERRORS = 'paid_with_errors',
  FAILED = 'failed',
}

export enum BatchUploadStatus {
  PENDING = 'pending',
  UPLOADED = 'uploaded',
  VALIDATED = 'validated',
  PROCESSING = 'processing',
  COMPLETE = 'complete',
  FAILED = 'failed',
}

export enum AcknowledgementOfDebtStatus {
  PENDING = 'pending',
  ACTIVE = 'active',
  PAID = 'paid',
  CANCELLED = 'cancelled',
}

export enum ServiceRequestStatus {
  REQUESTED = 'requested',
  ASSIGNED = 'assigned',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
  NO_DRIVERS_AVAILABLE = 'no_drivers_available',
}

export enum TripStatus {
  PLANNED = 'planned',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
}
